export default function ConductIcon({ nazivtipa }) {
  function getFirst() {
    if (!nazivtipa) return '';
    if (nazivtipa.includes('etvrto')) return '4';
    if (nazivtipa.includes('na tre')) return '3';
    if (nazivtipa.includes('na drugo')) return '2';
    if (nazivtipa.includes('na prvo')) return '1';
    return '';
  }

  return (
    <div className="icon-container">
      <div className="icon-style">{getFirst()}</div>
    </div>
  );
}
